import { render, staticRenderFns } from "./IndicatorsMap.vue?vue&type=template&id=bb9ba22a"
import script from "./IndicatorsMap.vue?vue&type=script&lang=js"
export * from "./IndicatorsMap.vue?vue&type=script&lang=js"
import style0 from "./IndicatorsMap.vue?vue&type=style&index=0&id=bb9ba22a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports